export default __webpack_public_path__ + "static/media/exam-overview-time-icon.fe167559.svg";